import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import { withDefaultStyles } from '../utils/material-ui/hoc';

class BYODForm extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <FormControl>
          <FormLabel>Source</FormLabel>
          <RadioGroup style={{ display: 'flex' }}
            aria-label="Source"
            name="source"
            // value={''}
            // onChange={handleChange}
            >
            <FormControlLabel value="s3" control={<Radio />} label="S3" />
            <FormControlLabel value="ftp" control={<Radio />} label="FTP" />
            <FormControlLabel value="manual" control={<Radio />} label="Manual" />
          </RadioGroup>
        </FormControl>
        <FormControl>
          <FormLabel>Format</FormLabel>
          <RadioGroup style={{ display: 'flex' }}
            aria-label="Format"
            name="format"
            // value={''}
            // onChange={handleChange}
            >
            <FormControlLabel value="excel" control={<Radio />} label="Excel" />
            <FormControlLabel value="xml" control={<Radio />} label="XML" />
            <FormControlLabel value="csv" control={<Radio />} label="CSV" />
          </RadioGroup>
        </FormControl>
        <FormControl>
          <FormLabel>Schedule</FormLabel>
          <RadioGroup style={{ display: 'flex' }}
            aria-label="Schedule"
            name="schedule"
            // value={''}
            // onChange={handleChange}
            >
            <FormControlLabel value="cron" control={<Radio />} label="Cron" />
            <FormControlLabel value="immediate" control={<Radio />} label="Immediate" />
          </RadioGroup>
        </FormControl>
      </div>
    );
  }

}
const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(BYODForm)));



// WEBPACK FOOTER //
// ./src/containers/byod-form.tsx